import ContainerHead from "../../molecules/ContainerHead";
import HomepageBannerContent from "./HomepageBannerContent";
import SwiperElement from "../../molecules/SwiperElement";
import {Tracking} from "../../../tracking/tracking";

class HomepageBannerSwiper {
  // BannerSection Swiper Parameters
  // 'slidesOffset*' seems to be a bit buggy, when entering different
  // breakpoint ranges, thus added the appropriate values to every bp
  private static swiperParams = {
    navigation: {
      nextEl: ".section-banner-homepage .swiper-btn-next",
      prevEl: ".section-banner-homepage .swiper-btn-prev",
    },
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    slidesPerView: 1.25,
    breakpoints: {
      481: {
        slidesPerView: 1.6,
      },
      651: {
        slidesPerView: 2.6,
      },
      768: {
        slidesPerView: 2.25,
      },
      851: {
        slidesPerView: 2.75,
      },
      941: {
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        slidesPerView: 3.66,
        rewind: true,
      },
      1132: {
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 4,
        rewind: true,
      },
    },
    on: {
      slideChange: () => {
        Tracking.sendEvent("Homepage.HomepageBannerSwiper.Swiped");
      },
    },
  };

  public static run(section: HTMLElement) {
    const slides = section.querySelectorAll<HTMLElement>("swiper-container swiper-slide");
    if (!slides.length) {
      return;
    }
    slides.forEach((slide) => {
      new HomepageBannerContent(slide);
    });

    const containerHead: HTMLElement | null = section.querySelector(".react-container-head");
    if (containerHead) {
      new ContainerHead(containerHead);
    }

    const navigationButtons: HTMLElement | null = section.querySelector(".swiper-navigation");
    if (navigationButtons !== null) {
      navigationButtons.style.display = "";
    }

    SwiperElement.run(section, HomepageBannerSwiper.swiperParams);
  }
}

export default HomepageBannerSwiper;
